import { PublisherPartner } from 'modules/incentivesMarket/modals/PublishIncentiveOffer/types/PublishIncentiveOfferModalContextType';

export const getPublisherAddressLine = (
  publisherPartner: PublisherPartner | null
): string => {
  const address = publisherPartner?.address;
  if (!address || typeof address !== 'object') return '';

  const { line1, zip, city, state, country } = address as Record<
    string,
    string | undefined
  >;
  return [line1, zip, city, state, country]
    .filter((v) => typeof v === 'string' && v.trim().length > 0)
    .join(', ');
};
